"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestartBtnComponent = exports.QuestionHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HeaderTop = _interopRequireDefault(require("../shared/HeaderTop"));
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useQuestionnaireNavigation = require("../../hooks/questionnaire/useQuestionnaireNavigation");
var _useCurrentQuestion = require("../../hooks/questionnaire/useCurrentQuestion");
var _services = require("../../services");
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _useLocalTheme2 = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _DynamicStepper = _interopRequireDefault(require("../DynamicStepper/DynamicStepper"));
var _useAppSelector = require("../../hooks/useAppSelector");
var _QuestionTitle = _interopRequireDefault(require("./QuestionTitle"));
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RestartWrapper = _styledComponents.default.div`
  display: flex;
  justify-content: flex-end;
`;
const QuestionnaireHeaderContainer = _styledComponents.default.div`
  width: ${_ref => {
  var _modalBody$contentWid, _modalBody$contentWid2;
  let {
    modalBody,
    breakpoints
  } = _ref;
  return modalBody !== null && modalBody !== void 0 && modalBody.contentWidth ? breakpoints.sm ? (_modalBody$contentWid = modalBody.contentWidth) === null || _modalBody$contentWid === void 0 ? void 0 : _modalBody$contentWid.sm : (_modalBody$contentWid2 = modalBody.contentWidth) === null || _modalBody$contentWid2 === void 0 ? void 0 : _modalBody$contentWid2.lg : '100%';
}};
`;
const StyledRestartWrapper = _styledComponents.default.div`
  ${props => props.iconStrokeColor && (0, _styledComponents.css)`
      & [class^='injected-svg'] {
        stroke: ${props.iconStrokeColor};
      }
    `}
`;
const RestartBtnComponent = _ref2 => {
  let {
    isRestartVisible,
    placement,
    onRestart
  } = _ref2;
  const restartBtnPlacement = (0, _useConfig.default)('uiSettings.restartBtnPlacement', 'header');
  const iconStrokeColor = (0, _useLocalTheme2.default)('iconStrokeColor', '');
  const mobileResetIconSize = (0, _useLocalTheme2.default)('questionnaireHeaderBtn.mobileResetIconSize', '2');
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  if (!isRestartVisible) return null;
  if (restartBtnPlacement !== placement) return null;
  const RenderingComponent = placement === 'header' ? _r10SourceLibrary.LinkWithIcon : _r10SourceLibrary.Link;
  return /*#__PURE__*/_react.default.createElement(StyledRestartWrapper, {
    iconStrokeColor: iconStrokeColor
  }, /*#__PURE__*/_react.default.createElement(RenderingComponent, {
    appearance: "secondary",
    text: placement === 'footer' ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
      weight: 3
    }, _services.Services.locale.localeString('Questionnaire.RestartIcon')) : _services.Services.locale.localeString('Questionnaire.RestartIcon'),
    state: "selected",
    id: "questionnaire-button-restart",
    icon: placement === 'header' && {
      name: 'refresh',
      justify: 'left'
    },
    onClick: onRestart,
    size: breakpoints.sm ? mobileResetIconSize : 2
  }));
};
exports.RestartBtnComponent = RestartBtnComponent;
const QuestionHeader = () => {
  var _useLocalTheme;
  const {
    questionIndex
  } = (0, _useCurrentQuestion.useCurrentQuestion)();
  const {
    onRestart,
    isRestartVisible,
    onRestartWithWarningMessage
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const {
    progressPercentage
  } = (0, _useQuestionnaireNavigation.useProgressPercentage)();
  const showVerticalStepper = (0, _useConfig.default)('uiSettings.stepper.showVerticalStepper', false);
  const currentQuestion = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentQuestion);
  const showStepper = (0, _react.useMemo)(() => !showVerticalStepper && (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.type) !== _constants.QUESTION_TYPE.INTRO_SCREEN, [currentQuestion, showVerticalStepper]);
  (0, _useCurrentQuestion.useViewQuestion)(questionIndex);
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const showProgressBar = (0, _useLocalTheme2.default)('showProgressBar', true);
  const showDivider = (0, _useLocalTheme2.default)('showDivider', true);
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    modalBody,
    header
  } = (_useLocalTheme = (0, _useLocalTheme2.default)()) !== null && _useLocalTheme !== void 0 ? _useLocalTheme : {};
  const showRestartWarningMessage = (0, _useLocalTheme2.default)('showRestartWarningMessage', false);
  const topSpacing = (0, _react.useMemo)(() => showVerticalStepper ? 0 : 3);
  const bottomSpacing = (0, _react.useMemo)(() => showProgressBar ? 3 : 0);
  const restartComponent = () => {
    return /*#__PURE__*/_react.default.createElement(RestartBtnComponent, {
      isRestartVisible: isRestartVisible,
      onRestart: showRestartWarningMessage ? onRestartWithWarningMessage : onRestart,
      placement: "header"
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      marginBottom: header === null || header === void 0 ? void 0 : header.marginBottom
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_HeaderTop.default, _extends({}, showModalView ? {
    actionComponent: restartComponent(),
    showDivider: showDivider
  } : {
    isCloseButtonHidden: true,
    headerText: _services.Services.locale.localeString('Questionnaire.FullPageTitle'),
    headerSubText: _services.Services.locale.localeString('Questionnaire.FullPageSubtitle')
  }, {
    id: "question-header"
  }))))), /*#__PURE__*/_react.default.createElement(QuestionnaireHeaderContainer, {
    modalBody: modalBody,
    breakpoints: breakpoints,
    "data-test-id": "header-container"
  }, showStepper && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    className: "dynamic_stepper"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_DynamicStepper.default, null))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: topSpacing,
      bottom: bottomSpacing
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'center',
    direction: 'column'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, !showModalView && /*#__PURE__*/_react.default.createElement(RestartWrapper, null, restartComponent()), showProgressBar && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ProgressBar, {
    value: progressPercentage,
    appearance: 'primary',
    dataAttributes: {
      'data-test-id': 'ProgressBar'
    }
  })))), !showVerticalStepper && /*#__PURE__*/_react.default.createElement(_QuestionTitle.default, null)));
};
exports.QuestionHeader = QuestionHeader;